import { useReveal } from "@/lib/useReveal";

export default function About() {
    const { ref, visible } = useReveal();
    return (
        <section
            id="o-vinarstvi"
            ref={ref}
            data-testid="about-section"
            className="py-24 md:py-36 px-6 md:px-12 bg-cream relative"
        >
            <div className="mx-auto max-w-[1500px] grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
                <div className={`lg:col-span-5 lg:sticky lg:top-32 self-start transition-all duration-1000 ${visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"}`}>
                    <p className="overline mb-6">O vinařství</p>
                    <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.95] text-ink">
                        Rodinná
                        <br />
                        <span className="font-serif-italic text-burgundy">tradice</span>
                    </h2>
                    <div className="hidden lg:block w-24 h-px bg-burgundy mt-10" />
                </div>

                <div className={`lg:col-span-7 space-y-8 transition-all duration-1000 delay-200 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
                    <p className="text-lg md:text-xl leading-relaxed text-ink first-letter:font-serif first-letter:text-7xl first-letter:font-medium first-letter:float-left first-letter:mr-3 first-letter:leading-[0.9] first-letter:text-burgundy">
                        Vinařství je součástí naší rodinné tradice po generace. S úctou k odkazu našich předků pečujeme o necelý hektar vlastních vinic, z jejichž hroznů vyrábíme vína s důrazem na kvalitu, poctivé řemeslo a charakter našeho kraje.
                    </p>

                    <div className="image-hover overflow-hidden ml-0 md:ml-12 -mr-6 md:-mr-12 my-12">
                        <img
                            src="https://i.ibb.co/hxfsZ40Z/2-A0-D7-B3-E-43-D8-4-A08-BC62-90-B7-B0-C21-BA5.jpg"
                            alt="Naše vinice"
                            className="w-full h-[320px] md:h-[480px] object-cover"
                        />
                    </div>

                    <p className="text-base md:text-lg leading-relaxed text-ink2 max-w-2xl">
                        O naše vinice pečujeme šetrně a s respektem k půdě, hrozny sklízíme ručně a ve sklepě pracujeme tradičními postupy. Každé víno necháváme přirozeně zrát a dáváme mu čas, aby vynikla jeho chuť, vůně a charakter. Od práce ve vinici až po naplnění lahve se soustředíme na kvalitu a osobitý charakter našich vín.
                    </p>

                    <div className="grid grid-cols-3 gap-6 md:gap-12 pt-12 mt-8 border-t border-ink/15">
                        <div data-testid="about-stat-years">
                            <div className="font-serif text-5xl md:text-7xl text-burgundy leading-none">200+</div>
                            <div className="mt-3 text-xs uppercase tracking-[0.2em] text-ink2">Let tradice</div>
                        </div>
                        <div data-testid="about-stat-hectares">
                            <div className="font-serif text-5xl md:text-7xl text-burgundy leading-none">0,9</div>
                            <div className="mt-3 text-xs uppercase tracking-[0.2em] text-ink2">Hektaru vinic</div>
                        </div>
                        <div data-testid="about-stat-wines">
                            <div className="font-serif text-5xl md:text-7xl text-burgundy leading-none">8</div>
                            <div className="mt-3 text-xs uppercase tracking-[0.2em] text-ink2">Generací rodu</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
